import React from 'react';
import { motion } from 'framer-motion';
import { Check, Sparkles, Star, Crown, ShoppingCart } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-[#1e3a5f] text-white pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden" data-id="element-392">
      {/* Background decorative elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#d4a574] opacity-5 blur-3xl rounded-l-full transform translate-x-1/2" data-id="element-393" />
      <div className="absolute bottom-0 left-0 w-1/4 h-1/2 bg-[#f4e4d7] opacity-5 blur-3xl rounded-r-full transform -translate-x-1/2" data-id="element-394" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-395">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-396">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="space-y-6" data-id="element-397">
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#d4a574]/20 to-[#c29463]/20 border border-[#d4a574]/40 rounded-full px-4 py-2 backdrop-blur-sm" data-id="element-398">
              <Crown className="w-4 h-4 text-[#d4a574]" data-id="element-399" />
              <span className="text-sm font-bold text-[#d4a574] tracking-wide uppercase" data-id="element-400">
                Edición Premium · Pack 7-en-1
              </span>
            </div>

            {/* Redesigned Heading */}
            <div className="space-y-3" data-id="element-401">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight" data-id="element-402">
                <span className="block text-white" data-id="element-403">Finanzas Fáciles</span>
                <span className="block mt-2" data-id="element-404">
                  <span className="text-white" data-id="element-405">para </span>
                  <span className="relative inline-block" data-id="element-406">
                    <span className="text-[#d4a574] italic" data-id="element-407">Mujeres</span>
                    <motion.div initial={{
                    scaleX: 0
                  }} animate={{
                    scaleX: 1
                  }} transition={{
                    duration: 0.8,
                    delay: 0.5
                  }} className="absolute -bottom-2 left-0 right-0 h-1 bg-gradient-to-r from-[#d4a574] to-transparent origin-left" data-id="element-408" />
                  </span>
                </span>
              </h1>

              <p className="text-xl md:text-2xl text-[#f4e4d7] font-light leading-relaxed" data-id="element-409">
                Tu plan de{' '}
                <span className="text-white font-semibold" data-id="element-410">30 días</span> para
                transformar el caos financiero en{' '}
                <span className="text-[#d4a574] font-semibold" data-id="element-411">
                  control total
                </span>{' '}
                de tu dinero
              </p>
            </div>

            <div className="space-y-3 py-4" data-id="element-412">
              {['Plan práctico de 15 minutos al día', 'Sin tecnicismos ni palabras complicadas', 'Diseñado para ingresos variables y emprendedoras', 'Acceso inmediato y de por vida'].map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.5,
              delay: 0.6 + index * 0.1
            }} className="flex items-start gap-3" data-id="element-413">
                  <div className="mt-1 bg-[#d4a574] rounded-full p-0.5" data-id="element-414">
                    <Check className="w-3 h-3 text-[#1e3a5f]" data-id="element-415" />
                  </div>
                  <span className="text-gray-200" data-id="element-416">{item}</span>
                </motion.div>)}
            </div>

            <p className="text-sm text-gray-400 italic" data-id="element-417">
              *Oferta de lanzamiento disponible por tiempo limitado. Acceso 100%
              digital.
            </p>
          </motion.div>

          {/* Visual Content - Actual Product Covers */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-418">
            <div className="relative z-10" data-id="element-419">
              {/* Main cover - prominent display */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.8,
              delay: 0.4
            }} className="relative" data-id="element-420">
                <img src="https://cdn.magicpatterns.com/uploads/rEbP9cdsB5wKXX71QsCx5Z/portada_finanzas_faciles.png" alt="Finanzas Fáciles para Mujeres - Guía Principal" className="w-full max-w-md mx-auto rounded-2xl shadow-2xl transform hover:scale-105 transition-transform duration-500" data-id="element-421" />

                {/* Floating bonus covers - left side */}
                <motion.img initial={{
                opacity: 0,
                x: -30,
                y: 30
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 0.6
              }} src="https://cdn.magicpatterns.com/uploads/82pjW85xD7qLnv8WLUSVLA/portada_bono1.png" alt="Dinero en Pareja y Familia" className="absolute -left-8 top-1/4 w-32 md:w-40 rounded-lg shadow-xl transform -rotate-6 hover:rotate-0 transition-transform duration-500" data-id="element-422" />

                <motion.img initial={{
                opacity: 0,
                x: -30,
                y: -30
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 1.0
              }} src="https://cdn.magicpatterns.com/uploads/dsMDdhavFW6Br34VYUL9Sg/portada_bono_6.png" alt="Mentalidad y Afirmaciones" className="absolute -left-6 bottom-1/4 w-28 md:w-36 rounded-lg shadow-xl transform -rotate-12 hover:rotate-0 transition-transform duration-500" data-id="element-423" />

                {/* Floating bonus covers - right side */}
                <motion.img initial={{
                opacity: 0,
                x: 30,
                y: 30
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 0.8
              }} src="https://cdn.magicpatterns.com/uploads/aqaWhvwqXbR7suvdSC7kHY/portada_bono2.png" alt="Plan para Salir de Deudas" className="absolute -right-8 top-1/2 w-32 md:w-40 rounded-lg shadow-xl transform rotate-6 hover:rotate-0 transition-transform duration-500" data-id="element-424" />

                <motion.img initial={{
                opacity: 0,
                x: 30,
                y: -30
              }} animate={{
                opacity: 1,
                x: 0,
                y: 0
              }} transition={{
                duration: 0.8,
                delay: 1.2
              }} src="https://cdn.magicpatterns.com/uploads/iowyRuUA8sVcfFG7ZcY8wE/portada_bono_5.png" alt="Obtén Ingresos Extra" className="absolute -right-6 bottom-1/4 w-28 md:w-36 rounded-lg shadow-xl transform rotate-12 hover:rotate-0 transition-transform duration-500" data-id="element-425" />
              </motion.div>

              {/* Trust badge */}
              <div className="absolute -top-6 -right-6 bg-white text-[#1e3a5f] p-4 rounded-xl shadow-xl transform rotate-6 animate-pulse z-20" data-id="element-426">
                <div className="flex items-center gap-1 mb-1" data-id="element-427">
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-428" />
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-429" />
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-430" />
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-431" />
                  <Star className="w-4 h-4 text-[#d4a574] fill-current" data-id="element-432" />
                </div>
                <p className="font-bold text-sm" data-id="element-433">"¡Me cambió la vida!"</p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}